import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    no: "01",
    title: "The Promise",
    body: "ChaiED began with a simple idea — that learning should be as accessible and comforting as a cup of chai. No jargon, no gatekeeping. Just Saral Bhasha (simple language) that meets you where you are.",
  },
  {
    no: "02",
    title: "The Mindset",
    body: "We believe grit beats talent. Motivation is the spark; consistency is the fuel. Every setback is a setup for a comeback. Zid hai toh jeet hai.",
  },
  {
    no: "03",
    title: "The Method",
    body: "Holistic learning that turns knowledge into wisdom. Real success stories, personality development, and a relentlessly positive attitude woven into everything we teach.",
  },
  {
    no: "04",
    title: "The Mission",
    body: "To bridge the gap between the classroom and the real world — making a generation of learners not just educated people, but truly employable, confident, and inspired.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="w-full max-w-none px-4 md:px-8 lg:px-12 pt-40 pb-20">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-chai-red mb-6">About ChaiED</p>
          <h1 className="font-heading font-bold uppercase tracking-tighter leading-[0.85] text-[13vw] md:text-[8vw]">
            As simple as<br /><span className="text-chai-red">a cup of chai.</span>
          </h1>
        </Reveal>
      </section>

      <section className="w-full max-w-none px-4 md:px-8 lg:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="md:sticky md:top-32">
              <h2 className="font-serif italic text-4xl md:text-6xl leading-tight">
                Empowering minds, shaping futures.
              </h2>
              <p className="font-body text-lg text-muted-foreground mt-6 max-w-md">
                Four chapters that define how we think, teach, and inspire — every single day.
              </p>
              <div className="mt-10 aspect-[4/5] overflow-hidden border-2 border-chai-ink max-w-sm">
                <img
                  src= "/images/photo-1698993082050-19ca94c62fb8.jpeg" //"https://images.unsplash.com/photo-1698993082050-19ca94c62fb8"
                  alt="Students learning together"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="md:col-span-6 md:col-start-7">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.05}>
                <div className="border-t border-chai-ink/15 py-10" data-testid={`chapter-${c.no}`}>
                  <div className="flex items-baseline gap-6">
                    <span className="font-mono text-chai-red text-lg">{c.no}</span>
                    <div>
                      <h3 className="font-heading text-4xl md:text-5xl font-bold tracking-tight">{c.title}</h3>
                      <p className="font-body text-lg text-muted-foreground mt-4">{c.body}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
